$(() => {
    $('[data-toggle="tooltip"]').tooltip();
});
